import React from 'react';
import { CollapsableLocation } from './CollapsableLocation';
import { NewTabContentProps } from './types';
import { MainContainer } from './styled';
import { useGetMaxBlockHeight } from '../useGetMaxBlockHeight';

export const NewTabContent = ({
  locations,
  chosenLocationIds,
  onChangeCheckboxHandler,
  onCheckGroupHandler,
  townships,
  isFullName
}: NewTabContentProps) => {
  const maxBlockHeight = useGetMaxBlockHeight(townships, locations);

  return (
    <MainContainer maxBlockHeight={maxBlockHeight}>
      {locations.map(location => (
        <CollapsableLocation
          key={location.id}
          {...{
            location,
            chosenLocationIds,
            onCheckGroupHandler,
            onChangeCheckboxHandler,
            townships,
            isFullName
          }}
        />
      ))}
    </MainContainer>
  );
};
